// PGOrganData
import React, { FC } from 'react';
import { Image } from '../../components/Image';
import Comma from '../../components/Comma';

import styles from './PGOrgan.module.scss';

interface Props {
  PGOrganData: { [key: string]: string };
  PGBrandImgDataList: Array<{ img: string; name: string }>;
  PGMediaImgDataList: Array<{ img: string; name: string }>;
  PGRemarkData: { [key: string]: string };
}
const PGOrgan: FC<Props> = (props) => {
  const { PGOrganData, PGBrandImgDataList, PGMediaImgDataList, PGRemarkData } = props;

  return (
    <section className={styles['pg-organ-box']}>
      <h2 className={styles['pg-organ-title']}>{PGOrganData.title}</h2>

      <h3 className={styles['pg-organ-title-sub']}>{PGOrganData.brandTitle}</h3>
      <div className={styles['organ-img-box']}>
        {PGBrandImgDataList?.map((item, index) => (
          <div key={index} className={styles['brand-img-box']}>
            <Image
              src={item.img}
              alt={item.name || '美团'}
              layout="fill"
              objectFit="cover"
              compressOptions={{ quality: 70, isTransparent: true }}
            />
          </div>
        ))}
      </div>

      <h3 className={styles['pg-organ-title-sub']}>{PGOrganData.mediaTitle}</h3>
      <div className={styles['organ-img-box']}>
        {PGMediaImgDataList?.map((item, index) => (
          <div key={index} className={styles['media-img-box']}>
            <Image
              src={item.img}
              alt={item.name || '美团'}
              layout="fill"
              objectFit="cover"
              compressOptions={{ quality: 70, isTransparent: true }}
            />
          </div>
        ))}
      </div>

      <div className={styles['pg-remark-box']}>
        <p>{PGRemarkData.title1}</p>
        <span className={styles['comma-box']}>
          <Comma />
        </span>
        <div className={styles['remark-wrap']}>
          <p>{PGRemarkData.title2}</p>
          <p className={styles['remark-email']}>{PGRemarkData.email}</p>
        </div>
      </div>
    </section>
  );
};
PGOrgan.defaultProps = {};

PGOrgan.displayName = 'PGOrgan';
export default PGOrgan;
